import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import React from 'react';
import * as XLSX from 'xlsx';
import { CarrierWeightPricing } from '../../../../models/entities/admin/carrierWeightPricing';
import { TNTExcelParser } from './TNTExcelParserV2';
type Props = {
    updateCarrierWeightPricing: (carrierWeightPricing: CarrierWeightPricing[]) => void;
    selectedCarrierCode: string;
};
const ExcelReader = ({ updateCarrierWeightPricing, selectedCarrierCode }: Props) => {
    const handleFileUpload = (event: any) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = async (evt: any) => {
            const data = new Uint8Array(evt.target.result);
            const workbook = XLSX.read(data, {
                type: 'array',
                cellDates: true,
                cellStyles: true
            });
            const tntCodes = [1000, 1001];
            if (tntCodes.includes(+selectedCarrierCode)) {
                const pricing = new TNTExcelParser(workbook).parseWorkbooks();
                console.log('Parsed Pricing:', pricing);
                console.table(pricing);
                updateCarrierWeightPricing(pricing.allPricing);
                return;
            }
        };
        reader.readAsArrayBuffer(file);
    };

    return (
        <Container maxWidth="sm">
            <Box>
                <Button variant="contained" component="label">
                    Upload XLSX File
                    <input type="file" accept="*" hidden onChange={handleFileUpload} />
                </Button>
            </Box>
        </Container>
    );
};

export default ExcelReader;
